<template>
  <div class="file-upload">
    <div class="file-upload__label">
      <input type="file" :id="id" class="input-file" v-on:change="onFileChange" :accept="extensiones">
      <i class="fa fa-upload"></i>
      <label :for="id">Seleccione archivo...</label>
    </div>
    <img class="file-upload__image" :class="{'file-upload__image--open': fileImage}" :src="image" @click="openImage" v-on-clickaway="away">      
  </div>  
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  watch : {
    defaultImage : function (value) {
      this.image = value;
    }
  },
  mixins: [ clickaway ],
  props : {
    defaultImage : {
      type : String,
      default : '',
      required : false
    },
    id:{
      type:String,
      dafault:'file',
      required:false
    },
    value : {
      required : false,
      default : ''
    },
    extensiones:{
      required:true
    },
    tamanoMaximo:{
      required: false,
      default: 3000000
    },
    descripcionMaximo:{
      required: false,
      default: '3mb'
    },
    pathDefault: {
      required: true
    },
    mostrarDescargar: {
      type: Boolean,
      required: false,
      default: false
    },
    cargarImagenDefecto: {
      type: Boolean,
      required: false,
      default: false
    },
    verMiniatura: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      image: this.defaultImage,
      fileImage: false,
      imageReturn : null,
    }
  },
  methods: {
    openImage () {
      if(this.verMiniatura)
        this.fileImage = !this.fileImage;
      else
        this.$emit('verImagen');
    },
    away () {
      if (this.fileImage) {
        this.fileImage = false;
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    setDefaultImage(){
      this.image = this.defaultImage;
    },
    createImage(file) {
      if(parseFloat(file.size) > parseFloat(this.tamanoMaximo)){
        swal.fire('Error','El peso del archivo no debe ser mayor a ' + this.descripcionMaximo, 'error')
      }else{
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.image = e.target.result;
          vm.imageReturn = e.target.result;
          if(vm.cargarImagenDefecto && vm.image.substring(0,10) != 'data:image'){
            if(vm.image.substring(0,20) == 'data:application/pdf')
              vm.image = '/images/imagen-pdf.jpg';
            else if(vm.image.substring(0,23) == 'data:application/msword' || vm.image.substring(0,76) == 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document')
              vm.image = '/images/imagen-word.png';
            else if(vm.image.substring(0,29) == 'data:application/vnd.ms-excel' || vm.image.substring(0,70) == 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
              vm.image = '/images/imagen-excel.png';
            else
              vm.image = '/images/imagen-office.jpg';
          }
          vm.$emit('input', vm.imageReturn);
          vm.$emit('imagenCargada');
        };
        reader.readAsDataURL(file);        
      }
      
    },
    recuperarImagen() {    
      return this.imageReturn;
    }
  },
  mounted : function(){   
    if(this.defaultImage == null)
        this.image = this.pathDefault;
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/FileUpload.vue